export default {"src":"/_next/static/media/pair-3.77cb9490.svg","height":371,"width":510,"blurWidth":0,"blurHeight":0};